import React, { useState } from "react";
import { Input } from "../components/Input";
import { Link } from "react-router-dom";
import { auth } from "../config/firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { ErrorMessage } from "../components/ErrorMessage";
import { ButtonSubmit } from "../components/ButtonSubmit";
import { useNavigate } from "react-router-dom";

export const Signin = () => {
  const [userData, setUserData] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      const form = e.target;
      const formData = new FormData(form);
      const formJson = Object.fromEntries(formData.entries());
      setUserData(formJson);
      await signInWithEmailAndPassword(auth, userData.email, userData.password);
      navigate("/books");
      console.log("User Sign in successfully!");
    } catch (error) {
      setErrorMessage("Enter a valid email or password");
      console.error("Error Sign in:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setErrorMessage("");
  };

  return (
    <div className="my-16 mx-auto flex flex-col w-[360px] min-h-550 p-7 shadow-lg rounded-lg border border-solid border-gray-200">
      <h3 className="text-3xl font-semibold text-green-600 text-center py-5 mb-5">
        SIGN IN
      </h3>
      <form onSubmit={handleSubmit} className="flex flex-col">
        <Input
          fildName="email"
          placeholder="Email address"
          type="email"
          handleChange={handleChange}
        />

        <Input
          fildName="password"
          placeholder="Password"
          type="password"
          handleChange={handleChange}
        />

        <ErrorMessage errorMessage={errorMessage} />

        <ButtonSubmit
          disabled={!userData.email || !userData.password}
          text="SIGN IN"
        />
      </form>

      <p className="text-gray-600 text-sm">
        Not a member?
        <Link
          to="/signup"
          className="text-green-600 ml-2 font-semibold text-base"
        >
          SIGN UP
        </Link>
      </p>
    </div>
  );
};
